import React, { useState, useEffect } from 'react';
import './Gallery.css';

// Import your local images
import image1 from './images/first.png';
import image2 from './images/second.jpg';
import image3 from './images/third.png';
import image4 from './images/fourth.jpg';
import image5 from './images/fifth.png';

const galleryImages = [
  { src: image1, title: "Expert Instructors", description: "Learn from industry professionals with years of experience" },
  { src: image2, title: "Modern Facilities", description: "State-of-the-art learning environments" },
  { src: image3, title: "Innovative Approach", description: "Cutting-edge teaching methodologies" },
  { src: image4, title: "Student Success", description: "Celebrating achievements and milestones" },
  { src: image5, title: "Community Building", description: "Creating lifelong connections" }
];

const Gallery = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      nextImage();
    }, 4000); // Increased to 4 seconds for better viewing

    return () => clearInterval(interval);
  }, [currentImageIndex]);

  const nextImage = () => {
    if (isTransitioning) return;
    
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
      setIsTransitioning(false);
    }, 800); // Match this with CSS transition duration
  };

  const currentImage = galleryImages[currentImageIndex];

  return (
    <section className="gallery-section" id="gallery">
      <div className="gallery-container">
        {/* Background Images */}
        <div className="gallery-background">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className={`background-image ${index === currentImageIndex ? 'active' : ''}`}
              style={{ backgroundImage: `url(${image.src})` }}
            />
          ))}
        </div>

        {/* Content Overlay */}
        <div className="gallery-content">
          <div className="content-wrapper">
            <div className="text-content">
              <div className="image-counter">
                <span className="current">{String(currentImageIndex + 1).padStart(2, '0')}</span>
                <span className="separator">/</span>
                <span className="total">{String(galleryImages.length).padStart(2, '0')}</span>
              </div>
              
              <h2 className="image-title">{currentImage.title}</h2>
              <p className="image-description">{currentImage.description}</p>
              
              <div className="progress-indicator">
                {galleryImages.map((_, index) => (
                  <div 
                    key={index}
                    className={`progress-dot ${index === currentImageIndex ? 'active' : ''}`}
                    onClick={() => {
                      setCurrentImageIndex(index);
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Gradient Overlay for better text readability */}
        <div className="gradient-overlay"></div>
      </div>
    </section>
  );
};

export default Gallery;